"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResponseType = void 0;
var JSON_REGEXP = /[/+]json($|[^-\w])/i;
var BINARY_MIMES = ['multipart/encrypted', 'application/octet-stream'];
function getResponseType(contentTypeRaw) {
    var contentType = contentTypeRaw;
    if (typeof contentType === 'string') {
        contentType = [contentType];
    }
    if (contentType) {
        if (contentType.some(function (t) { return JSON_REGEXP.test(t); })) {
            return 'json';
        }
        if (contentType.some(function (t) { return BINARY_MIMES.includes(t); })) {
            return 'binary';
        }
    }
    return 'string';
}
exports.getResponseType = getResponseType;
//# sourceMappingURL=getResponseType.js.map